import { type ParsedUrlQuery } from 'querystring';

import { type Config } from '@packages/config';

export const ONBOARDING_QUERY_PARAM = 'lassDichInspirieren';
export const INSPIRING_SEARCH_V2_PREVIEW_QUERY_PARAM = 'previewV2';

export const INSPIRING_SEARCH_V1 = 'v1' as const;
export const INSPIRING_SEARCH_V2 = 'v2' as const;

/**
 * Get the activation status for Inspiring Search features (usable on server and client)
 */
export const getInspiringSearchSettingsInternal = (query: ParsedUrlQuery, config: Config) => {
  const {
    search: { isInspiringSearchEnabled: isEnabledInConfig },
  } = config;

  const forceAiEnhancement = !!query.alwaysAi || ONBOARDING_QUERY_PARAM in query;
  const forceV2Preview = INSPIRING_SEARCH_V2_PREVIEW_QUERY_PARAM in query;

  const inspiringSearchVersion = forceV2Preview ? INSPIRING_SEARCH_V2 : INSPIRING_SEARCH_V1;

  const isInspiringSearchEnabled = isEnabledInConfig || !!query.enableAi || forceAiEnhancement;

  return {
    forceAiEnhancement,
    isInspiringSearchEnabled,
    inspiringSearchVersion,
  };
};

/**
 * Get the activation status for Inspiring Search features (server-side)
 */
export const getInspiringSearchSettings = (query: ParsedUrlQuery, config: Config) =>
  getInspiringSearchSettingsInternal(query, config);
